import React, {Fragment} from 'react'
import style from '../scss/components/PlayButton.module.scss'
import {ReactComponent as PlayIcon} from '../assets/play-icon.svg'

type PlayButtonProps = {
    onClick?(): CallableFunction
}

const PlayButton = (props: PlayButtonProps) => {
    return (
        <Fragment>
            <div className={style.OpacityLayer} onClick={props.onClick}/>
            <div className={style.BackgroundLayer} onClick={props.onClick}>
                <PlayIcon/>
            </div>
        </Fragment>

    )
}

export default PlayButton
